import { RestockingPriorityTier } from "__graphql__/types";

export enum RestockingItemStatus {
  done = "DONE",
  new = "NEW",
}

export type RestockingProduct = {
  sku: string;
  name: string;
  imageUrl: string | null;
  isBio: boolean | null;
  countryOfOriginCode: string | null;
  shelfLetter: string | null;
  shelfNumber: string | null;
  shelf: string | null;
  stockOnShelf: number;
  numberOfShelfFacings: number | null;
  numberOfShelfStackings: number | null;
  isShelvedInHandlingUnits: boolean | null;
  productClassification?: string[] | null;
};

export type TranslatedRestockingProduct = RestockingProduct & {
  countryOfOriginName: string | null;
};

export type PublicRestockingItem = {
  sku: string;
  product: RestockingProduct | null;
  priorityTier?: RestockingPriorityTier | null;
};

export type RestockingItem = {
  sku: string;
  product: RestockingProduct | null;
  status: RestockingItemStatus;
  priorityTier?: RestockingPriorityTier | null;
};

export type TranslatedRestockingItem = Omit<RestockingItem, "product"> & {
  product: TranslatedRestockingProduct | null;
};
